import React, { useContext } from 'react';
import {
  CAB_FROM_AIRPORT,
  CAB_TO_AIRPORT,
  OUTSTATION_ONE_WAY,
  OUTSTATION_ROUND_TRIP,
  RENTALS
} from '../../../constants/tripTypes';
import { getAppEnv } from '../../../../config/env';
import { TripTypeOption } from './TripTypeOption';
import {
  CabsLandingContext,
  CabsLandingDispatchContext
} from '../../../CabsLandingContext';
import { SET_TRAVELFOR } from '../cabsLandingPageState';
const env = getAppEnv();
const { PUBLIC_URL } = env.raw;

export const TripTypeOptions = ({ style }) => {
  const cabsLandingContext = useContext(CabsLandingContext);
  const dispatch = useContext(CabsLandingDispatchContext);

  const { travelFor } = cabsLandingContext;

  const setTravelFor = triptype => {
    dispatch && dispatch({ type: SET_TRAVELFOR, newStateValue: triptype });
  };

  return (
    <>
      {travelFor != RENTALS ? (
        <div
          style={{
            marginTop: '10px',
            backgroundColor: 'rgb(247, 247, 247)',
            border: '1px solid rgb(231, 231, 231)',
            marginBottom: '14px'
          }}
          className="cabsLandingRsw rsw"
        >
          <div>
            <div className="makeFlex alignCenter">
              <img
                className="appendRight10"
                src={`${PUBLIC_URL}/static/public/round_trip_gray.webp`}
                height={'24px'}
                width={'24px'}
                alt="trip"
              />
              {travelFor == CAB_FROM_AIRPORT || travelFor == CAB_TO_AIRPORT ? (
                <>
                  <TripTypeOption
                    optionName={CAB_TO_AIRPORT}
                    setOption={setTravelFor}
                    isActiveOption={travelFor === CAB_TO_AIRPORT}
                    style={style}
                    title={'Travel To Airport'}
                  />
                  <TripTypeOption
                    optionName={CAB_FROM_AIRPORT}
                    setOption={setTravelFor}
                    isActiveOption={travelFor === CAB_FROM_AIRPORT}
                    style={style}
                    title={'Travel From Airport'}
                  />
                </>
              ) : null}
              {travelFor == OUTSTATION_ONE_WAY ||
              travelFor == OUTSTATION_ROUND_TRIP ? (
                <>
                  <TripTypeOption
                    optionName={OUTSTATION_ONE_WAY}
                    setOption={setTravelFor}
                    isActiveOption={travelFor === OUTSTATION_ONE_WAY}
                    style={style}
                    title={'One Way'}
                  />
                  <TripTypeOption
                    optionName={OUTSTATION_ROUND_TRIP}
                    setOption={setTravelFor}
                    isActiveOption={travelFor === OUTSTATION_ROUND_TRIP}
                    style={style}
                    title={'Round Trip'}
                  />
                </>
              ) : null}
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
};
